module.exports = __webpack_public_path__ + "img/IMG-20210719-WA0007.d7fa03e2.jpg";